import { render, staticRenderFns } from "./AdvantagesSection.vue?vue&type=template&id=0b909251&scoped=true"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js"
import style0 from "./AdvantagesSection.vue?vue&type=style&index=0&id=0b909251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b909251",
  null
  
)

export default component.exports